import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { envActions } from '@buy-viasat/redux/src/env';
import { scheduleInstallationActions } from '@buy-viasat/redux/src/schedule-installation';

import { PersistGate } from 'redux-persist/integration/react';
import { ViasatTheme } from 'shared/assets/styles/theme';
import { Navigator } from 'shared/Navigator';
import ThemeContext from 'shared/providers/hooks/ThemeContext';
import { persistor, store } from 'shared/store';
import history from 'shared/utils/history';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import '@vst/beam/index.scss';

const queryClient = new QueryClient();

const App = (): JSX.Element => {
  useEffect((): void => {

    // set env -- only enter necessary items here.  PLEASE AVOID ACCESS KEYS
    store.dispatch(envActions.setEnv({ aemUrl:  process.env['REACT_APP_AEM_URL'] }));
    // Collect date
    store.dispatch(scheduleInstallationActions.setToday(new Date()));
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Router history={history as any}>
              <ThemeContext.Provider value={ViasatTheme}>
                <Navigator />
              </ThemeContext.Provider>
            </Router>
          </PersistGate>
        </Provider>
    </QueryClientProvider>
  );
};

export default App;
